module.exports = __webpack_public_path__ + "img/amg_noname4amigo.c325bb7.png";